import React, { Fragment, useEffect, useState } from "react"
import { connect } from "react-redux"
import {
  Container,
  CardMedia,
  FormControl,
  Input,
  Button,
  FormHelperText,
  Box
} from "@material-ui/core"
import { withStyles } from "@material-ui/styles"
import styles from "./styles"
import { Formik, Form } from "formik"
import * as Yup from "yup"
// import SendIcon from "@material-ui/icons/Send"
// import SplitBottomNav from "components/SplitBottomNav"
import { useHistory } from "react-router-dom"
import { receiveUpload } from "actions/upload"
import { submitPost } from "actions/posts"
// import Loading from "components/Loading"
import { openSnackBar } from "actions/snack-bar"
import { setIsLoading } from "actions/isLoading"
import GooglePlacesAutocomplete from "react-google-places-autocomplete"
import { resizeImage } from "actions/upload"
import TelegramIcon from "@material-ui/icons/Telegram"
import LoaderButton from "components/LoaderButton"
const CreatePostSchema = Yup.object().shape({
  location: Yup.string(),
  // .required("Location Required"),
  // files: Yup.array().required("Required"),
  description: Yup.string().required("Description Required")
})
const imageReader = new FileReader()
const videoReader = new FileReader()

const CreatePost = ({
  classes,
  dispatch,
  file,
  uploadType,
  user,
  currentOrg,
  isLoading
}) => {
  const history = useHistory()

  const handleCancel = () => {
    history.push("/app/feed")

    // Remove file from state
    dispatch(receiveUpload())
  }

  const [fileForUpload, setFileForUpload] = useState(null)
  const [source, setSource] = useState(null)

  imageReader.addEventListener("load", () => {
    dispatch(resizeImage(imageReader.result, 800, 800))
      .then(res => {
        setFileForUpload(res)
        dispatch(setIsLoading(false))
        setSource(res)
      })
      .catch(error => {
        dispatch(setIsLoading(false))
        dispatch(openSnackBar({ message: "Image failed to upload." }))
      })
  })
  imageReader.addEventListener("onError", e => {
    console.error(e)
    dispatch(setIsLoading(false))
    dispatch(openSnackBar({ message: "Image failed to load." }))
  })

  videoReader.addEventListener("load", () => {
    dispatch(setIsLoading(false))
    setFileForUpload(videoReader.result)
    if (file) {
      setSource(URL.createObjectURL(file))
    }
  })
  videoReader.addEventListener("onError", e => {
    console.error(e)
    dispatch(setIsLoading(false))
    dispatch(openSnackBar({ message: "Video failed to load." }))
  })

  useEffect(() => {
    if (file) {
      if (uploadType === "image") {
        imageReader.readAsDataURL(file)
      } else {
        dispatch(setIsLoading(false))
        setFileForUpload(file)
        setSource(URL.createObjectURL(file))
      }
    } else {
      // take back to feed if there is no image
      handleCancel()
    }
  }, [file])

  return (
    <Fragment>
      <Formik
        initialValues={{
          location: "",
          files: [],
          description: ""
        }}
        validationSchema={CreatePostSchema}
        onSubmit={(values, setFieldValue) => {
          const submitData = {
            user_id: user.user_id,
            org_id: currentOrg.id,
            location: values.location,
            description: values.description,
            file: fileForUpload
          }
          dispatch(submitPost(submitData))
            .then(res => JSON.parse(res.text))
            .then(res => {
              dispatch(openSnackBar({ message: res.message }))
              history.push("/app/submitted")
            })
            .catch(error => {
              return error
            })
            .catch(err => {
              console.log(err)
            })
          return
        }}
      >
        {({ handleChange, errors, touched, setFieldValue }) => (
          <Form className={classes.form}>
            {source && (
              <CardMedia
                component={uploadType === "image" ? "img" : "video"}
                controls={uploadType === "video"}
                className={classes.media}
                src={source}
                title="Upload preview"
                preload="metadata"
              />
            )}{" "}
            {/* <Container className={classes.container}>
              <FormControl
                error={!!(errors.location && touched.location)}
                className={classes.locationControl}
              >
                <GooglePlacesAutocomplete
                  placeholder="Add Location"
                  suggestionsClassNames={{
                    container: classes.locationSuggestionContainer,
                    suggestion: classes.locationSuggestion,
                    suggestionActive: classes.locationSuggestionActive
                  }}
                  loader={<div style={{ display: "none" }} />}
                  onSelect={place =>
                    setFieldValue("location", place.description)
                  }
                  renderInput={props => (
                    <Box display="flex" alignItems="center">
                      <TelegramIcon className={classes.sendIconContainer} />
                      <Input
                        type="text"
                        className={classes.location}
                        id="location"
                        name="location"
                        variant="filled"
                        disableUnderline
                        onKeyUp={e => setFieldValue("location", e.target.value)}
                        {...props}
                      />
                      <FormHelperText className={classes.locationHelper}>
                        {touched.location && errors.location}
                      </FormHelperText>
                    </Box>
                  )}
                />
              </FormControl>
            </Container>
            <FormHelperText>{touched.files && errors.files}</FormHelperText> */}
            {/* <Box className={classes.grayLine} /> */}
            <Container className={classes.container}>
              <FormControl
                error={!!(errors.description && touched.description)}
                className={classes.descriptionControl}
              >
                {/* <FormLabel className={classes.label} htmlFor="description">
                  Short Description*
                </FormLabel> */}
                <Input
                  name="description"
                  className={classes.textArea}
                  onChange={handleChange}
                  id="description"
                  variant="filled"
                  multiline
                  rows="3"
                  disableUnderline
                  placeholder="Write a short description here..."
                />
                <FormHelperText>
                  {touched.description && errors.description}
                </FormHelperText>
              </FormControl>
              <Box
                display="flex"
                alignItems="flex-end"
                justifyContent="center"
                className={classes.buttonsContainer}
              >
                <Button
                  variant="text"
                  className={classes.cancelButton}
                  onClick={handleCancel}
                >
                  cancel
                </Button>
                <LoaderButton
                  classes={{
                    button: classes.submitButton,
                    colorPrimary: classes.spinnerColor
                  }}
                  type="submit"
                  working={isLoading}
                >
                  submit
                </LoaderButton>
              </Box>
            </Container>
          </Form>
        )}
      </Formik>
    </Fragment>
  )
}

const mapStateToProps = state => {
  return {
    file: state.upload.file,
    uploadType: state.upload.uploadType,
    user: state.authentication.authenticatedUser,
    currentOrg: state.organization.currentOrg,
    isLoading: state.isLoading.loading
  }
}

const connector = connect(mapStateToProps)

export default connector(withStyles(styles)(CreatePost))



// WEBPACK FOOTER //
// ./src/pages/App/CreatePost/index.js